import _ from "lodash";
import dayjs from "dayjs";
require("dayjs/locale/es");

// Ciclo de vida de la salida, tal como lo deriva el backend (DashboardOperadorService).
// Es distinto del estado de puntualidad de statusHelper.ESTADOS: uno responde "¿ya salió?"
// y el otro "¿va a tiempo?". Los dos se usan juntos en la misma tarjeta.
export const ESTADOS_SALIDA = {
  en_curso: { label: "En curso", bg: "#daf7fe", bd: "#9de9fd", ink: "#0a7f97" },
  programada: { label: "Programada", bg: "#eff2f7", bd: "#e9ebec", ink: "#495057" },
  realizada: { label: "Realizada", bg: "#e2f8ed", bd: "#b1edcf", ink: "#1d6b47" },
};

export const CHIPS = [
  { key: "todas", label: "Todas", conteo: "total" },
  { key: "en_curso", label: "En curso", conteo: "en_curso" },
  { key: "programada", label: "Programadas", conteo: "programadas" },
  { key: "realizada", label: "Realizadas", conteo: "realizadas" },
];

// .locale() por instancia: dayjs.locale("es") global cambia el idioma de toda la SPA
export const fechaLarga = (fecha) =>
  fecha ? _.capitalize(dayjs(fecha).locale("es").format("dddd D [de] MMMM")) : "";

export const filtrar = (salidas, filtro) =>
  filtro === "todas" ? salidas : (salidas ?? []).filter((s) => s.estado === filtro);

/*
  Salida a destacar: la que está en curso y arrancó más tarde (si el operador tuviera dos
  solapadas, la vigente es la última). Si no hay ninguna en curso se destaca la próxima
  programada, y si el día ya terminó la última realizada.
*/
export const pickSalidaEnCurso = (salidas) => {
  const lista = salidas ?? [];
  return (
    _.last(lista.filter((s) => s.estado === "en_curso")) ??
    _.first(lista.filter((s) => s.estado === "programada")) ??
    _.last(lista.filter((s) => s.estado === "realizada")) ??
    null
  );
};

export const esHoy = (fecha) => dayjs(fecha).isSame(dayjs(), "day");
